import type { Template, Site, SecurityLog, User } from '../types';

// ─── Mock Templates ──────────────────────────────────────────────────

export const mockTemplates: Template[] = [
  {
    templateId: 'portfolio-minimal',
    name: 'Portfolio Minimal',
    category: 'portfolio',
    description: 'Template portfolio bersih dan moden untuk designer & freelancer.',
    tags: ['responsive', 'dark-mode', 'fast-load'],
    rating: 4.8,
    usageCount: 234,
    isPremium: false,
    htmlContent: `<!DOCTYPE html>
<html lang="ms">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>{{siteName}}</title>
  <style>
    :root { --primary: {{primaryColor}}; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Segoe UI', sans-serif; background: #0f0f0f; color: #fff; }
    .hero { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 2rem; }
    .badge { background: var(--primary); color: white; padding: 0.3rem 1rem; border-radius: 99px; font-size: 0.85rem; margin-bottom: 1.5rem; display: inline-block; }
    h1 { font-size: clamp(2.5rem, 6vw, 4.5rem); font-weight: 800; line-height: 1.1; margin-bottom: 1rem; }
    h1 span { color: var(--primary); }
    p { color: #aaa; font-size: 1.1rem; max-width: 500px; margin-bottom: 2rem; }
    .btn { background: var(--primary); color: white; padding: 0.8rem 2rem; border-radius: 8px; text-decoration: none; font-weight: 600; }
    .work { padding: 4rem 2rem; max-width: 900px; margin: 0 auto; }
    .work h2 { font-size: 2rem; margin-bottom: 2rem; }
    .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem; }
    .card { background: #1a1a1a; border-radius: 12px; padding: 1.5rem; border: 1px solid #333; }
    .card h3 { color: var(--primary); margin-bottom: 0.5rem; }
    .card p { font-size: 0.9rem; margin: 0; }
  </style>
</head>
<body>
  <section class="hero">
    <div class="badge">✨ Portfolio</div>
    <h1>Hai, saya <span>{{siteName}}</span></h1>
    <p>{{description}}</p>
    <a href="mailto:{{contactEmail}}" class="btn">Hubungi Saya</a>
  </section>
  <section class="work">
    <h2>Kerja Terkini</h2>
    <div class="grid">
      <div class="card"><h3>Projek 1</h3><p>Rekaan laman web moden untuk klien korporat.</p></div>
      <div class="card"><h3>Projek 2</h3><p>Aplikasi mobile dengan UI/UX yang menakjubkan.</p></div>
      <div class="card"><h3>Projek 3</h3><p>Branding dan identiti visual untuk startup.</p></div>
    </div>
  </section>
</body>
</html>`,
    variables: [
      { key: 'siteName', label: 'Nama / Jenama', type: 'text', defaultValue: 'Ahmad Design', placeholder: 'cth: Ahmad Design Studio', required: true },
      { key: 'primaryColor', label: 'Warna Utama', type: 'color', defaultValue: '#6366f1' },
      { key: 'description', label: 'Deskripsi Ringkas', type: 'textarea', defaultValue: 'Designer & developer yang passionate tentang rekaan digital yang memberi impak.' },
      { key: 'contactEmail', label: 'Email Hubungi', type: 'text', defaultValue: 'hello@example.com', placeholder: 'nama@email.com' },
    ],
  },
  {
    templateId: 'business-pro',
    name: 'Business Professional',
    category: 'business',
    description: 'Template korporat profesional untuk SME dan syarikat.',
    tags: ['responsive', 'corporate', 'seo-ready'],
    rating: 4.6,
    usageCount: 189,
    isPremium: false,
    htmlContent: `<!DOCTYPE html>
<html lang="ms">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>{{companyName}}</title>
  <style>
    :root { --primary: {{primaryColor}}; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Segoe UI', sans-serif; color: #1a1a2e; }
    header { background: white; box-shadow: 0 2px 10px rgba(0,0,0,0.08); padding: 1rem 2rem; display: flex; justify-content: space-between; align-items: center; position: sticky; top: 0; z-index: 100; }
    .logo { font-size: 1.4rem; font-weight: 800; color: var(--primary); }
    nav a { margin-left: 2rem; text-decoration: none; color: #555; font-size: 0.95rem; }
    .hero { background: linear-gradient(135deg, var(--primary), #1a1a2e); color: white; padding: 6rem 2rem; text-align: center; }
    .hero h1 { font-size: clamp(2rem, 5vw, 3.5rem); margin-bottom: 1rem; }
    .hero p { font-size: 1.1rem; opacity: 0.9; max-width: 600px; margin: 0 auto 2rem; }
    .btn { background: white; color: var(--primary); padding: 0.8rem 2rem; border-radius: 8px; text-decoration: none; font-weight: 700; }
    .services { padding: 4rem 2rem; max-width: 1000px; margin: 0 auto; }
    .services h2 { text-align: center; font-size: 2rem; margin-bottom: 3rem; }
    .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 2rem; }
    .card { padding: 2rem; border-radius: 12px; border: 1px solid #e5e7eb; transition: transform 0.2s; }
    .card:hover { transform: translateY(-4px); box-shadow: 0 10px 30px rgba(0,0,0,0.1); }
    .icon { font-size: 2rem; margin-bottom: 1rem; }
    .card h3 { margin-bottom: 0.5rem; color: var(--primary); }
    footer { background: #1a1a2e; color: white; padding: 2rem; text-align: center; }
  </style>
</head>
<body>
  <header>
    <div class="logo">{{companyName}}</div>
    <nav>
      <a href="#services">Perkhidmatan</a>
      <a href="#about">Tentang</a>
      <a href="mailto:{{contactEmail}}" style="color:var(--primary);font-weight:600">Hubungi</a>
    </nav>
  </header>
  <section class="hero">
    <h1>{{tagline}}</h1>
    <p>{{description}}</p>
    <a href="mailto:{{contactEmail}}" class="btn">Dapatkan Sebut Harga</a>
  </section>
  <section class="services" id="services">
    <h2>Perkhidmatan Kami</h2>
    <div class="grid">
      <div class="card"><div class="icon">💼</div><h3>Perundingan</h3><p>Nasihat pakar untuk mengembangkan perniagaan anda dengan strategi terbukti.</p></div>
      <div class="card"><div class="icon">📊</div><h3>Analitik</h3><p>Data-driven insights untuk membuat keputusan yang lebih baik.</p></div>
      <div class="card"><div class="icon">🚀</div><h3>Pembangunan</h3><p>Penyelesaian teknologi moden yang berskala mengikut keperluan anda.</p></div>
    </div>
  </section>
  <footer><p>© 2026 {{companyName}}. Hak Cipta Terpelihara.</p></footer>
</body>
</html>`,
    variables: [
      { key: 'companyName', label: 'Nama Syarikat', type: 'text', defaultValue: 'Syarikat Maju Sdn Bhd', required: true },
      { key: 'primaryColor', label: 'Warna Utama', type: 'color', defaultValue: '#1e40af' },
      { key: 'tagline', label: 'Tagline', type: 'text', defaultValue: 'Penyelesaian Perniagaan Terbaik untuk Anda' },
      { key: 'description', label: 'Deskripsi', type: 'textarea', defaultValue: 'Kami menyediakan perkhidmatan berkualiti tinggi dengan harga berpatutan.' },
      { key: 'contactEmail', label: 'Email', type: 'text', defaultValue: 'info@syarikat.com' },
    ],
  },
  {
    templateId: 'blog-clean',
    name: 'Blog Clean',
    category: 'blog',
    description: 'Template blog bersih dan mudah dibaca untuk penulis dan kreator.',
    tags: ['clean', 'readable', 'minimal'],
    rating: 4.7,
    usageCount: 156,
    isPremium: false,
    htmlContent: `<!DOCTYPE html>
<html lang="ms">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>{{blogName}}</title>
  <style>
    :root { --primary: {{primaryColor}}; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: Georgia, serif; background: #fafafa; color: #333; }
    .container { max-width: 680px; margin: 0 auto; padding: 2rem 1.5rem; }
    header { padding: 2rem 0; border-bottom: 1px solid #e5e5e5; margin-bottom: 3rem; }
    .blog-name { font-size: 1.8rem; font-weight: 900; color: var(--primary); }
    .tagline { color: #777; font-size: 0.95rem; margin-top: 0.3rem; }
    .featured { background: white; border-radius: 12px; padding: 2rem; margin-bottom: 2rem; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
    .featured-badge { background: var(--primary); color: white; font-size: 0.75rem; padding: 0.2rem 0.6rem; border-radius: 99px; display: inline-block; margin-bottom: 1rem; }
    h2 { font-size: 1.6rem; margin-bottom: 0.8rem; line-height: 1.3; }
    .meta { color: #999; font-size: 0.85rem; margin-bottom: 1rem; }
    p { line-height: 1.8; color: #444; }
    .post-list { list-style: none; }
    .post-item { padding: 1.5rem 0; border-bottom: 1px solid #eee; }
    .post-item h3 { font-size: 1.1rem; margin-bottom: 0.4rem; }
    .post-item h3 a { color: #333; text-decoration: none; }
    .post-item h3 a:hover { color: var(--primary); }
  </style>
</head>
<body>
  <div class="container">
    <header>
      <div class="blog-name">{{blogName}}</div>
      <div class="tagline">{{tagline}}</div>
    </header>
    <article class="featured">
      <div class="featured-badge">⭐ Pilihan Editor</div>
      <h2>{{featuredTitle}}</h2>
      <div class="meta">{{authorName}} · 25 Ogos 2026 · 5 minit bacaan</div>
      <p>{{featuredExcerpt}}</p>
    </article>
    <ul class="post-list">
      <li class="post-item"><h3><a href="#">Cara Memulakan Blog dalam 5 Minit</a></h3><div class="meta">20 Ogos 2026</div></li>
      <li class="post-item"><h3><a href="#">10 Tips Menulis Konten Berkualiti</a></h3><div class="meta">15 Ogos 2026</div></li>
      <li class="post-item"><h3><a href="#">Kenapa SEO Penting untuk Blog Anda</a></h3><div class="meta">10 Ogos 2026</div></li>
    </ul>
  </div>
</body>
</html>`,
    variables: [
      { key: 'blogName', label: 'Nama Blog', type: 'text', defaultValue: 'Blog Saya', required: true },
      { key: 'primaryColor', label: 'Warna Utama', type: 'color', defaultValue: '#dc2626' },
      { key: 'tagline', label: 'Tagline Blog', type: 'text', defaultValue: 'Perkongsian idea dan pengalaman' },
      { key: 'authorName', label: 'Nama Penulis', type: 'text', defaultValue: 'Ahmad' },
      { key: 'featuredTitle', label: 'Tajuk Utama', type: 'text', defaultValue: 'Selamat Datang ke Blog Saya' },
      { key: 'featuredExcerpt', label: 'Petikan Utama', type: 'textarea', defaultValue: 'Ini adalah tempat di mana saya berkongsi pemikiran, pengalaman, dan ilmu yang berguna.' },
    ],
  },
  {
    templateId: 'landing-bold',
    name: 'Landing Bold CTA',
    category: 'landing',
    description: 'Template landing page berani dengan CTA kuat untuk produk dan servis.',
    tags: ['cta', 'conversion', 'bold', 'modern'],
    rating: 4.5,
    usageCount: 203,
    isPremium: false,
    htmlContent: `<!DOCTYPE html>
<html lang="ms">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>{{productName}}</title>
  <style>
    :root { --primary: {{primaryColor}}; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Segoe UI', sans-serif; }
    .hero { min-height: 100vh; background: linear-gradient(135deg, var(--primary) 0%, #0f172a 100%); color: white; display: flex; align-items: center; justify-content: center; text-align: center; padding: 2rem; }
    .container { max-width: 700px; }
    .badge { background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.3); padding: 0.4rem 1.2rem; border-radius: 99px; font-size: 0.85rem; display: inline-block; margin-bottom: 2rem; }
    h1 { font-size: clamp(2.5rem, 6vw, 4rem); font-weight: 900; line-height: 1.1; margin-bottom: 1.5rem; }
    p { font-size: 1.15rem; opacity: 0.85; margin-bottom: 2.5rem; line-height: 1.7; }
    .cta-btn { display: inline-block; background: white; color: var(--primary); font-size: 1.1rem; font-weight: 800; padding: 1rem 2.5rem; border-radius: 12px; text-decoration: none; margin-right: 1rem; margin-bottom: 1rem; }
    .cta-outline { display: inline-block; border: 2px solid rgba(255,255,255,0.5); color: white; font-size: 1rem; font-weight: 600; padding: 0.9rem 2rem; border-radius: 12px; text-decoration: none; }
    .features { padding: 4rem 2rem; background: white; }
    .features-grid { max-width: 900px; margin: 0 auto; display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 2rem; }
    .feature-item { text-align: center; padding: 2rem; }
    .feature-icon { font-size: 2.5rem; margin-bottom: 1rem; }
    .feature-item h3 { font-size: 1.1rem; margin-bottom: 0.5rem; color: #1a1a2e; }
    .feature-item p { font-size: 0.9rem; color: #666; margin: 0; opacity: 1; }
  </style>
</head>
<body>
  <section class="hero">
    <div class="container">
      <div class="badge">🚀 {{productCategory}}</div>
      <h1>{{headline}}</h1>
      <p>{{subheadline}}</p>
      <a href="{{ctaUrl}}" class="cta-btn">{{ctaText}}</a>
      <a href="#features" class="cta-outline">Ketahui Lebih</a>
    </div>
  </section>
  <section class="features" id="features">
    <div class="features-grid">
      <div class="feature-item"><div class="feature-icon">⚡</div><h3>Pantas &amp; Mudah</h3><p>Setup dalam masa kurang dari 5 minit tanpa sebarang kemahiran teknikal.</p></div>
      <div class="feature-item"><div class="feature-icon">🔒</div><h3>100% Selamat</h3><p>Data anda dilindungi dengan enkripsi peringkat bank.</p></div>
      <div class="feature-item"><div class="feature-icon">💎</div><h3>Nilai Terbaik</h3><p>Harga paling kompetitif di pasaran dengan kualiti premium.</p></div>
    </div>
  </section>
</body>
</html>`,
    variables: [
      { key: 'productName', label: 'Nama Produk', type: 'text', defaultValue: 'ProdukKu', required: true },
      { key: 'primaryColor', label: 'Warna Utama', type: 'color', defaultValue: '#7c3aed' },
      { key: 'productCategory', label: 'Kategori Produk', type: 'text', defaultValue: 'Produk Digital' },
      { key: 'headline', label: 'Headline', type: 'text', defaultValue: 'Ubah Cara Anda Bekerja Hari Ini' },
      { key: 'subheadline', label: 'Sub-headline', type: 'textarea', defaultValue: 'Penyelesaian all-in-one yang direka untuk menjimatkan masa dan meningkatkan produktiviti anda.' },
      { key: 'ctaText', label: 'Teks Butang CTA', type: 'text', defaultValue: 'Cuba Sekarang — Percuma' },
      { key: 'ctaUrl', label: 'URL CTA', type: 'url', defaultValue: 'https://t.me/username' },
    ],
  },
  {
    templateId: 'store-grid',
    name: 'Store Grid Katalog',
    category: 'store',
    description: 'Template kedai online dengan grid produk yang kemas dan mudah dilayari.',
    tags: ['ecommerce', 'catalog', 'grid', 'responsive'],
    rating: 4.4,
    usageCount: 178,
    isPremium: false,
    htmlContent: `<!DOCTYPE html>
<html lang="ms">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>{{storeName}}</title>
  <style>
    :root { --primary: {{primaryColor}}; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Segoe UI', sans-serif; background: #f9fafb; }
    header { background: white; padding: 1rem 2rem; display: flex; justify-content: space-between; align-items: center; box-shadow: 0 1px 4px rgba(0,0,0,0.08); }
    .logo { font-size: 1.3rem; font-weight: 800; color: var(--primary); }
    .order-btn { background: var(--primary); color: white; padding: 0.5rem 1.2rem; border-radius: 8px; text-decoration: none; font-size: 0.9rem; font-weight: 600; }
    .hero { background: linear-gradient(135deg, var(--primary), #0f172a); color: white; text-align: center; padding: 3rem 2rem; }
    .hero h1 { font-size: 2.2rem; margin-bottom: 0.5rem; }
    .hero p { opacity: 0.85; }
    .products { max-width: 1000px; margin: 0 auto; padding: 3rem 2rem; }
    .products h2 { font-size: 1.5rem; margin-bottom: 1.5rem; color: #111; }
    .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 1.5rem; }
    .product-card { background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06); transition: transform 0.2s; }
    .product-card:hover { transform: translateY(-4px); }
    .product-img { aspect-ratio: 1; background: #e5e7eb; display: flex; align-items: center; justify-content: center; font-size: 3rem; }
    .product-info { padding: 1rem; }
    .product-name { font-weight: 600; font-size: 0.95rem; margin-bottom: 0.3rem; color: #111; }
    .product-price { color: var(--primary); font-weight: 700; font-size: 1.1rem; margin-bottom: 0.8rem; }
    .buy-btn { display: block; width: 100%; background: var(--primary); color: white; text-align: center; padding: 0.5rem; border-radius: 6px; text-decoration: none; font-size: 0.85rem; font-weight: 600; }
  </style>
</head>
<body>
  <header>
    <div class="logo">🛍️ {{storeName}}</div>
    <a href="https://wa.me/{{whatsappNumber}}" class="order-btn">Order Sekarang</a>
  </header>
  <section class="hero">
    <h1>{{storeName}}</h1>
    <p>{{storeTagline}}</p>
  </section>
  <section class="products">
    <h2>Semua Produk</h2>
    <div class="grid">
      <div class="product-card"><div class="product-img">👕</div><div class="product-info"><div class="product-name">Baju Premium</div><div class="product-price">RM 45.00</div><a href="https://wa.me/{{whatsappNumber}}" class="buy-btn">Beli via WhatsApp</a></div></div>
      <div class="product-card"><div class="product-img">👖</div><div class="product-info"><div class="product-name">Seluar Casual</div><div class="product-price">RM 65.00</div><a href="https://wa.me/{{whatsappNumber}}" class="buy-btn">Beli via WhatsApp</a></div></div>
      <div class="product-card"><div class="product-img">👟</div><div class="product-info"><div class="product-name">Kasut Sport</div><div class="product-price">RM 120.00</div><a href="https://wa.me/{{whatsappNumber}}" class="buy-btn">Beli via WhatsApp</a></div></div>
      <div class="product-card"><div class="product-img">🧢</div><div class="product-info"><div class="product-name">Topi Trendy</div><div class="product-price">RM 28.00</div><a href="https://wa.me/{{whatsappNumber}}" class="buy-btn">Beli via WhatsApp</a></div></div>
    </div>
  </section>
</body>
</html>`,
    variables: [
      { key: 'storeName', label: 'Nama Kedai', type: 'text', defaultValue: 'Kedai Saya', required: true },
      { key: 'primaryColor', label: 'Warna Utama', type: 'color', defaultValue: '#059669' },
      { key: 'storeTagline', label: 'Tagline Kedai', type: 'text', defaultValue: 'Barangan berkualiti, harga berpatutan' },
      { key: 'whatsappNumber', label: 'Nombor WhatsApp', type: 'text', defaultValue: '60123456789', placeholder: '60123456789' },
    ],
  },
  {
    templateId: 'personal-linktree',
    name: 'Personal Link-in-Bio',
    category: 'personal',
    description: 'Template link-in-bio yang playful untuk influencer dan individu.',
    tags: ['linktree', 'social', 'playful', 'mobile-first'],
    rating: 4.9,
    usageCount: 312,
    isPremium: false,
    htmlContent: `<!DOCTYPE html>
<html lang="ms">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>{{displayName}}</title>
  <style>
    :root { --primary: {{primaryColor}}; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Segoe UI', sans-serif; background: linear-gradient(135deg, #0f172a, var(--primary)); min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 1rem; }
    .card { width: 100%; max-width: 400px; text-align: center; color: white; }
    .avatar { width: 90px; height: 90px; border-radius: 50%; background: linear-gradient(135deg, #fff3, #fff1); border: 3px solid rgba(255,255,255,0.4); margin: 0 auto 1rem; display: flex; align-items: center; justify-content: center; font-size: 2.5rem; }
    h1 { font-size: 1.5rem; font-weight: 800; margin-bottom: 0.3rem; }
    .handle { opacity: 0.7; font-size: 0.9rem; margin-bottom: 0.8rem; }
    .bio { opacity: 0.8; font-size: 0.9rem; line-height: 1.6; margin-bottom: 2rem; }
    .links { display: flex; flex-direction: column; gap: 0.8rem; }
    .link-btn { display: flex; align-items: center; gap: 0.8rem; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: white; padding: 0.9rem 1.2rem; border-radius: 12px; text-decoration: none; font-weight: 600; font-size: 0.95rem; backdrop-filter: blur(10px); transition: background 0.2s; }
    .link-btn:hover { background: rgba(255,255,255,0.2); }
    .link-icon { font-size: 1.2rem; }
    .socials { display: flex; justify-content: center; gap: 1rem; margin-top: 2rem; }
    .social-btn { width: 42px; height: 42px; border-radius: 50%; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center; color: white; text-decoration: none; font-size: 1.1rem; }
  </style>
</head>
<body>
  <div class="card">
    <div class="avatar">{{avatarEmoji}}</div>
    <h1>{{displayName}}</h1>
    <div class="handle">{{handle}}</div>
    <p class="bio">{{bio}}</p>
    <div class="links">
      <a href="{{link1Url}}" class="link-btn"><span class="link-icon">🌐</span>{{link1Text}}</a>
      <a href="{{link2Url}}" class="link-btn"><span class="link-icon">📸</span>{{link2Text}}</a>
      <a href="{{link3Url}}" class="link-btn"><span class="link-icon">🎵</span>{{link3Text}}</a>
      <a href="{{link4Url}}" class="link-btn"><span class="link-icon">💼</span>{{link4Text}}</a>
    </div>
    <div class="socials">
      <a href="#" class="social-btn">𝕏</a>
      <a href="#" class="social-btn">📷</a>
      <a href="#" class="social-btn">🎥</a>
      <a href="#" class="social-btn">💬</a>
    </div>
  </div>
</body>
</html>`,
    variables: [
      { key: 'displayName', label: 'Nama Paparan', type: 'text', defaultValue: 'Nama Saya', required: true },
      { key: 'primaryColor', label: 'Warna Tema', type: 'color', defaultValue: '#7c3aed' },
      { key: 'avatarEmoji', label: 'Emoji Avatar', type: 'text', defaultValue: '🌟' },
      { key: 'handle', label: 'Handle/Username', type: 'text', defaultValue: '@namasaya' },
      { key: 'bio', label: 'Bio Ringkas', type: 'textarea', defaultValue: 'Content creator | Digital artist | Malaysia 🇲🇾' },
      { key: 'link1Text', label: 'Link 1 - Teks', type: 'text', defaultValue: 'Website Saya' },
      { key: 'link1Url', label: 'Link 1 - URL', type: 'url', defaultValue: 'https://example.com' },
      { key: 'link2Text', label: 'Link 2 - Teks', type: 'text', defaultValue: 'Instagram' },
      { key: 'link2Url', label: 'Link 2 - URL', type: 'url', defaultValue: 'https://instagram.com' },
      { key: 'link3Text', label: 'Link 3 - Teks', type: 'text', defaultValue: 'TikTok' },
      { key: 'link3Url', label: 'Link 3 - URL', type: 'url', defaultValue: 'https://tiktok.com' },
      { key: 'link4Text', label: 'Link 4 - Teks', type: 'text', defaultValue: 'Hubungi Saya' },
      { key: 'link4Url', label: 'Link 4 - URL', type: 'url', defaultValue: 'mailto:hello@example.com' },
    ],
  },
];

// ─── Mock Sites ──────────────────────────────────────────────────────

export const mockSites: Site[] = [
  {
    siteId: 'site-001',
    ownerId: 'user-001',
    siteName: 'Kedai Baju Online',
    htmlContent: '',
    htmlSize: 12480,
    publicUrl: 'https://kedaibaju.web.app',
    status: 'published',
    templateId: 'store-grid',
    templateName: 'Store Grid Katalog',
    security: {
      passwordEnabled: false,
      passwordHash: null,
      rateLimitEnabled: true,
      rateLimitPerMinute: 100,
      ipWhitelistEnabled: false,
      ipWhitelist: [],
      ipBlacklistEnabled: true,
      ipBlacklist: ['185.220.0.0/16'],
      captchaEnabled: true,
      expiryEnabled: false,
      expiryDate: null,
      botProtectionEnabled: true,
      securityScore: 75,
    },
    analytics: {
      totalViews: 1247,
      uniqueVisitors: 456,
      lastViewAt: new Date(Date.now() - 1000 * 60 * 15),
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 14),
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2),
    publishedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 13),
    expiresAt: null,
  },
  {
    siteId: 'site-002',
    ownerId: 'user-001',
    siteName: 'Portfolio Ahmad',
    htmlContent: '',
    htmlSize: 8930,
    publicUrl: 'https://ahmadportfolio.web.app',
    status: 'published',
    templateId: 'portfolio-minimal',
    templateName: 'Portfolio Minimal',
    security: {
      passwordEnabled: true,
      passwordHash: 'hashed',
      rateLimitEnabled: true,
      rateLimitPerMinute: 60,
      ipWhitelistEnabled: false,
      ipWhitelist: [],
      ipBlacklistEnabled: false,
      ipBlacklist: [],
      captchaEnabled: false,
      expiryEnabled: false,
      expiryDate: null,
      botProtectionEnabled: false,
      securityScore: 55,
    },
    analytics: {
      totalViews: 892,
      uniqueVisitors: 234,
      lastViewAt: new Date(Date.now() - 1000 * 60 * 60 * 2),
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 30),
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 5),
    publishedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 28),
    expiresAt: null,
  },
  {
    siteId: 'site-003',
    ownerId: 'user-001',
    siteName: 'Blog Teknologi',
    htmlContent: '',
    htmlSize: 15200,
    publicUrl: '',
    status: 'draft',
    templateId: 'blog-clean',
    templateName: 'Blog Clean',
    security: {
      passwordEnabled: false,
      passwordHash: null,
      rateLimitEnabled: false,
      rateLimitPerMinute: 60,
      ipWhitelistEnabled: false,
      ipWhitelist: [],
      ipBlacklistEnabled: false,
      ipBlacklist: [],
      captchaEnabled: false,
      expiryEnabled: false,
      expiryDate: null,
      botProtectionEnabled: false,
      securityScore: 0,
    },
    analytics: {
      totalViews: 0,
      uniqueVisitors: 0,
      lastViewAt: null,
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 3),
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 1),
    publishedAt: null,
    expiresAt: null,
  },
];

// ─── Mock Security Logs ──────────────────────────────────────────────

export const mockSecurityLogs: SecurityLog[] = [
  { logId: 'log-001', siteId: 'site-001', eventType: 'page_view', ipHash: 'sha256:a1b2c3', country: 'MY', userAgent: 'Mozilla/5.0 (iPhone)', timestamp: new Date(Date.now() - 1000 * 60 * 5), blocked: false, reason: null },
  { logId: 'log-002', siteId: 'site-001', eventType: 'ip_blocked', ipHash: 'sha256:x9y8z7', country: 'RU', userAgent: 'curl/7.68.0', timestamp: new Date(Date.now() - 1000 * 60 * 30), blocked: true, reason: 'IP dalam blocklist' },
  { logId: 'log-003', siteId: 'site-001', eventType: 'rate_limited', ipHash: 'sha256:m4n5o6', country: 'CN', userAgent: 'python-requests/2.28', timestamp: new Date(Date.now() - 1000 * 60 * 60), blocked: true, reason: 'Lebih 100 req/min' },
  { logId: 'log-004', siteId: 'site-001', eventType: 'password_failed', ipHash: 'sha256:p7q8r9', country: 'MY', userAgent: 'Mozilla/5.0 (Android)', timestamp: new Date(Date.now() - 1000 * 60 * 60 * 3), blocked: false, reason: 'Kata laluan salah' },
  { logId: 'log-005', siteId: 'site-001', eventType: 'bot_detected', ipHash: 'sha256:s1t2u3', country: 'US', userAgent: 'Googlebot/2.1', timestamp: new Date(Date.now() - 1000 * 60 * 60 * 6), blocked: false, reason: null },
  { logId: 'log-006', siteId: 'site-001', eventType: 'captcha_passed', ipHash: 'sha256:v4w5x6', country: 'MY', userAgent: 'Mozilla/5.0 (Windows)', timestamp: new Date(Date.now() - 1000 * 60 * 60 * 8), blocked: false, reason: null },
];

// ─── Mock User ───────────────────────────────────────────────────────

export const mockUser: User = {
  uid: 'user-001',
  email: 'ahmad@example.com',
  displayName: 'Ahmad Razak',
  plan: 'free',
  sitesCount: 3,
  maxSites: 3,
};

// ─── Analytics Chart Data ────────────────────────────────────────────

export const mockAnalyticsDaily = [
  { date: '19 Ogs', views: 98, unique: 45 },
  { date: '20 Ogs', views: 134, unique: 67 },
  { date: '21 Ogs', views: 87, unique: 41 },
  { date: '22 Ogs', views: 203, unique: 98 },
  { date: '23 Ogs', views: 176, unique: 82 },
  { date: '24 Ogs', views: 245, unique: 112 },
  { date: '25 Ogs', views: 304, unique: 143 },
];
